//@flow

import React, {useState} from 'react';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {makeStyles} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import EditCategories from './EditCategories';
import CategoryForm from './CategoryForm';
import {
  useBlogCategories,
  useBlogCategoriesModal,
} from '../../utils/blog-category';
import Toast from '../../../../elements/Toast';

type Props = {
  onClose?: () => void,
};

const useStyle = makeStyles(theme => ({
  root: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
}));

type Sections = 'ADD' | 'EDIT';

type ToastAlert = {
  message: string,
  severity: 'success' | 'error' | 'info' | 'warning',
};

export default function BlogCategoryModal(props: Props) {
  const {onClose} = props;

  const [toast, setToast] = useState<ToastAlert | null>(null);

  const classes = useStyle();

  const categories = useBlogCategories();

  const {closeModal, showModal} = useBlogCategoriesModal();

  const [currentSection, setCurrentSection] = useState<Sections>('ADD');

  const handleChangeSection = () => {
    if (currentSection === 'ADD') setCurrentSection('EDIT');
    if (currentSection === 'EDIT') setCurrentSection('ADD');
  };

  const buttonLabel =
    currentSection === 'EDIT' ? 'Agregar Categorias' : 'Editar Categorias';

  const handleClose = () => {
    closeModal();
    onClose && onClose();
  };

  const handleSuccess = (message: string) => {
    setToast({
      message,
      severity: 'success',
    });

    handleClose();
  };

  const handleError = () => {
    setToast({
      message: 'Ocurrió un error al crear la categoría',
      severity: 'error',
    });
  };

  return (
    <>
      <CustomModal open={!!showModal} handleCloseModal={handleClose}>
        <aside className={classes.root}>
          {currentSection === 'EDIT' ? (
            <EditCategories
              onSubmitSuccess={() => handleSuccess('Categoría editada')}
              onSubmitError={handleError}
            />
          ) : (
            <CategoryForm
              onSubmitSuccess={() => handleSuccess('Categoría creada')}
              onSubmitError={handleError}
            />
          )}

          <CustomButton
            variant="outlined"
            fullWidth
            onClick={handleChangeSection}
            disabled={categories.length === 0}
            type="button"
          >
            {buttonLabel}
          </CustomButton>
        </aside>
      </CustomModal>
      <Toast
        open={!!toast}
        onClose={() => {
          setToast(null);
        }}
        closeDelay={5000}
        severity={toast?.severity}
      >
        {toast?.message}
      </Toast>
    </>
  );
}
